export default {
  cancel: 'Cancel',
  collapse_expand: 'Collapse/Expand',
  collapsed: 'Collapsed',
  confirm: 'Confirm',
  continue: 'Continue',
  clone: 'Clone'
}
